<div #scrollContainer class="assetCard__sitesTableContainer">
  @if (!scrolledToEnd) {
    <div class="scrollOverflow">
      <div class="scrollOverflowIconContainer">
        <pp-icon
          class="scrollOverflowIcon"
          [ppSrc]="EIconPath.ICON_ARROW_DOWN"
          ppColor="grey-300"
        ></pp-icon>
        <div></div>
      </div>
    </div>
  }
  <pp-asset-card-sites-table-header class="assetCard__tableHeader">
  </pp-asset-card-sites-table-header>
  <div class="assetCard__sitesScrollContainer">
    @for (site of ppSites; track site) {
      <pp-asset-card-sites-table-row
        [ppAssetSite]="site"
        (ppNavigate)="navigateToSite($event)"
      ></pp-asset-card-sites-table-row>
    }
  </div>
</div>
